import React from "react";
import { RecordSuggester } from "../RecordSuggester/RecordSuggester";
export const RecordSuggesterPluginView = ({ view, suggesterCallbacksRegistry, mentionService }) => {
    return (React.createElement(RecordSuggester, { view: view, suggesterCallbacksRegistry: suggesterCallbacksRegistry, mentionService: mentionService }));
};
